import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import { ThemeProvider } from "./context/ThemeContext";
import "./index.css";

// Pages
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import ClientProfile from "./pages/ClientProfile";
import AgentChat from "./pages/AgentChat";
import Users from "./pages/Users";
import Settings from "./pages/Settings";
import Usage from "./pages/Usage";
import Semaforo from "./pages/Semaforo";
import DirectorChat from "./pages/DirectorChat";
import SocialScheduler from "./pages/SocialScheduler";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

function PrivateRoute({ children, roles, module: moduleName }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  if (moduleName && !user.modules?.includes(moduleName)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/politicas-de-privacidad" element={<PrivacyPolicy />} />
            <Route path="/condiciones-del-servicio" element={<TermsOfService />} />
            <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="clients" element={<Clients />} />
              <Route path="clients/:id" element={<ClientProfile />} />
              <Route path="agents/:agentId" element={<AgentChat />} />
              <Route path="users" element={<PrivateRoute roles={["super_admin"]}><Users /></PrivateRoute>} />
              <Route path="settings" element={<PrivateRoute roles={["super_admin"]}><Settings /></PrivateRoute>} />
              <Route path="usage" element={<PrivateRoute roles={["super_admin"]}><Usage /></PrivateRoute>} />
              <Route path="semaforo" element={<PrivateRoute roles={["super_admin","team_leader"]}><Semaforo /></PrivateRoute>} />
              <Route path="director" element={<PrivateRoute roles={["super_admin"]}><DirectorChat /></PrivateRoute>} />
              <Route path="social-scheduler" element={<PrivateRoute module="social_scheduler"><SocialScheduler /></PrivateRoute>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
